import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setSummary(state, payload) {
    state.summary = payload;
  },
  setAdding(state, payload) {
    state.isAdding = payload;
  },
  addQuarters(state, payload) {
    state.list.push(...payload);
  },
  setPaging(state, payload) {
    state.paging = payload;
  },
  setDetail(state, payload) {
    state.detail = payload;
  },
};
